import axios from "axios";
import { V1_API_ORIGIN } from "../../config/constants.config";
import axiosInstance from "../../api/axiosInstance";

export const LiveCallsService = (pacId) => {
  if (pacId) {
    return axiosInstance.get(`/messages/get-live-messages?currentPage=1&perPage=100&pacIds=${pacId}`);
  } else {
    return axiosInstance.get(`/messages/get-live-messages?currentPage=1&perPage=100`);
  }
}

export const getUserServices = () => {
  if (typeof window !== 'undefined') {
    const uid = localStorage.getItem("uid");
    return axiosInstance.get(`/users/services?userId=${uid}`);
  }
}
